{
  "en": {
    "wysiwyg": {
      "actions": {
        "alignCenter": "Align Center",
        "alignLeft": "Align Left",
        "alignRight": "Align Right",
        "blockType": "Block Type",
        "blockquote": "Quote",
        "bold": "Bold",
        "bulletList": "Bullet List",
        "code": "Code",
        "codeBlock": "Code Block",
        "fontFamily": "Font Family",
        "fontSize": "Font Size",
        "h1": "Heading 1",
        "h2": "Heading 2",
        "h3": "Heading 3",
        "highlight": "Highlight",
        "horizontalRule": "Horizontal Rule",
        "iframe": "Embed iFrame",
        "images": "Insert Images",
        "italic": "Italic",
        "katex": "LaTeX Formula",
        "katexBlock": "LaTeX Formula Block",
        "link": "Link",
        "more": "Insert Options",
        "orderedList": "Ordered List",
        "redo": "Redo",
        "specialCharacters": "Special Characters",
        "strikethrough": "Strikethrough",
        "table": "Table",
        "textColor": "Text color",
        "underline": "Underline",
        "undo": "Undo"
      },
      "blockTypes": {
        "five": "Heading 5",
        "four": "Heading 4",
        "one": "Heading 1",
        "paragraph": "Paragraph",
        "six": "Heading 6",
        "three": "Heading 3",
        "two": "Heading 2"
      },
      "dialogs": {
        "deleteTable": {
          "text": "The table will be removed along with all its content.",
          "title": "Delete table?"
        },
        "iframe": {
          "text": "Enter the URL of the page to embed as an iFrame in the text.",
          "title": "Embed iFrame"
        },
        "link": {
          "text": "Enter the URL the selected text should link to.",
          "title": "Insert link"
        },
        "urlPrompt": {
          "label": "URL",
          "placeholder": "Example: https://example.com"
        }
      },
      "specialCharactersModal": {
        "categories": {
          "Arrows": "Arrows",
          "Basic Latin": "Basic Latin",
          "Currency Symbols": "Currency Symbols",
          "Dingbats": "Dingbats",
          "Enclosed Alphanumerics": "Enclosed Alphanumerics",
          "General Punctuation": "General Punctuation",
          "Geometric Shapes": "Geometric Shapes",
          "Greek and Coptic": "Greek and Coptic",
          "Latin Extended-A": "Latin Extended-A",
          "Latin Extended-B": "Latin Extended-B",
          "Latin-1 Supplement": "Latin-1 Supplement",
          "Mathematical Operators": "Mathematical Operators",
          "Miscellaneous Symbols": "Miscellaneous Symbols",
          "Miscellaneous Technical": "Miscellaneous Technical",
          "Superscripts and Subscripts": "Superscripts and Subscripts"
        },
        "header": "Special Characters"
      }
    }
  }
}
